const arrImgs = Array.from({ length: 30 }, (_, i) => i + 1)
export const whatAwaitsYouMoc = {
    title: 'O troféu que te espera no Palco do GCE',
    images: arrImgs.map((img) => `last-event/${img}.webp`),
}
